import TYPES from '@/modules/shared/types';

// Domain
import {
  RiskToleranceQuestionsRepository,
} from '../../domain/repositories/risk-tolerance-questions-repository';
import {
  RiskToleranceQuestionsEntity,
} from '../../domain/entities/risk-tolerance-questions-entity';
import {
  RiskToleranceQuestionsDto,
} from '../../domain/dtos/risk-tolerance-questions-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class RiskToleranceQuestionsHttpRepository
implements RiskToleranceQuestionsRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/risk-tolerance-questions/investment-product-fund-type/`;

  get(risk_tolerance_questions_dto: RiskToleranceQuestionsDto):
    Promise<Array<RiskToleranceQuestionsEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}${risk_tolerance_questions_dto.investment_product_id}/`)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
